import { createRouterTransport } from "@connectrpc/connect";

import { AdminService } from "schema/gen/es/chiikipoint/adminconsole/v2/service_connect";

import {
  mockCreateCompany,
  mockGetAllCities,
  mockGetCategories,
  mockGetMyCompanies,
  mockUpdateCompany,
} from "./admin/companies";
import {
  mockCreateDistributionCampaign,
  mockCreateStandaloneDistributionCode,
  mockGetDistributionCampaigns,
  mockGetDistributionCodes,
  mockGetStandaloneDistributionCode,
} from "./admin/distribution";
import { mockGetAllFundSources, mockGetFundSourceFilters, mockSetFundSourceFilters } from "./admin/fundSources";
import {
  mockCancelNotificationByPersonalInformation,
  mockCreateNotification,
  mockCreateNotificationByPersonalInformation,
  mockGetNotificationByPersonalInformationHistories,
  mockGetNotificationHistories,
} from "./admin/notifications";
import {
  mockCreateStaff,
  mockCreateStore,
  mockCreateStoreStaff,
  mockDeleteStoreParameter,
  mockDeleteStoreStaff,
  mockGetStoreStaffs,
  mockIssueBalance,
  mockUpdateStore,
  mockUpdateStoreStaff,
  mockUpdateStoreImage,
} from "./admin/stores";
import { mockGetUser, mockGetUsers } from "./admin/users";
import {
  mockCreateHokkaidoR8HouseholderCodeUsesAsPaperVoucher,
  mockCreateHokkaidoR8HouseholderCodeUsesAsStaffMatch,
  mockCreateHokkaidoR8HouseholderPostalReturns,
  mockExportHokkaidoR8HouseholderMynaApplications,
  mockGetHokkaidoR8HouseholderPaperVouchersByPeriod,
  mockGetHokkaidoR8HouseholderPostalReturnsByPeriod,
  mockSearchHokkaidoR8HouseholderCodeStatuses,
  mockUploadHokkaidoHouseholderCSV,
} from "./admin/hokkaido";

export * from "./admin/companies";
export * from "./admin/distribution";
export * from "./admin/fundSources";
export * from "./admin/notifications";
export * from "./admin/stores";
export * from "./admin/users";
export * from "./admin/utils";

export const adminServiceMockTransport = createRouterTransport(
  ({ service }) => {
    service(AdminService, {
      getMyCompanies: mockGetMyCompanies,
      getAllCities: mockGetAllCities,
      getCategories: mockGetCategories,
      createCompany: mockCreateCompany,
      updateCompany: mockUpdateCompany,
      createStore: mockCreateStore,
      updateStore: mockUpdateStore,
      updateStoreImage: mockUpdateStoreImage,
      deleteStoreParameter: mockDeleteStoreParameter,
      createStaff: mockCreateStaff,
      getStoreStaffs: mockGetStoreStaffs,
      createStoreStaff: mockCreateStoreStaff,
      updateStoreStaff: mockUpdateStoreStaff,
      deleteStoreStaff: mockDeleteStoreStaff,
      issueBalance: mockIssueBalance,
      getUsers: mockGetUsers,
      getUser: mockGetUser,
      getAllFundSources: mockGetAllFundSources,
      getFundSourceFilters: mockGetFundSourceFilters,
      setFundSourceFilters: mockSetFundSourceFilters,
      getDistributionCampaigns: mockGetDistributionCampaigns,
      createDistributionCampaign: mockCreateDistributionCampaign,
      getDistributionCodes: mockGetDistributionCodes,
      getStandaloneDistributionCode: mockGetStandaloneDistributionCode,
      createStandaloneDistributionCode: mockCreateStandaloneDistributionCode,
      createNotification: mockCreateNotification,
      createNotificationByPersonalInformation:
        mockCreateNotificationByPersonalInformation,
      cancelNotificationByPersonalInformation:
        mockCancelNotificationByPersonalInformation,
      getNotificationHistories: mockGetNotificationHistories,
      getNotificationByPersonalInformationHistories:
        mockGetNotificationByPersonalInformationHistories,
      uploadHokkaidoHouseholderCSV: mockUploadHokkaidoHouseholderCSV,
      createHokkaidoR8HouseholderCodeUsesAsPaperVoucher:
        mockCreateHokkaidoR8HouseholderCodeUsesAsPaperVoucher,
      searchHokkaidoR8HouseholderCodeStatuses:
        mockSearchHokkaidoR8HouseholderCodeStatuses,
      createHokkaidoR8HouseholderPostalReturns:
        mockCreateHokkaidoR8HouseholderPostalReturns,
      getHokkaidoR8HouseholderPaperVouchersByPeriod:
        mockGetHokkaidoR8HouseholderPaperVouchersByPeriod,
      getHokkaidoR8HouseholderPostalReturnsByPeriod:
        mockGetHokkaidoR8HouseholderPostalReturnsByPeriod,
      exportHokkaidoR8HouseholderMynaApplications:
        mockExportHokkaidoR8HouseholderMynaApplications,
      createHokkaidoR8HouseholderCodeUsesAsStaffMatch:
        mockCreateHokkaidoR8HouseholderCodeUsesAsStaffMatch,
    });
  },
);
